import { useTheme } from "@mui/material"
import { useContextState } from "../../../../hooks/theme"

function useStyles() {
    const { breakpoints } = useTheme()
    const { colors: color } = useContextState()
    return {
        body: {
            padding: 3,
            width: '100%',
            height: '100%',
        },
        hg100: {
            height:'100%'
        },
        hg90: {
            minHeight:'95%'
        },
        buttonsContainer: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .back': {
                width: '80px',
                height: '36px',
                /* textTransform: 'uppercase', */
            },
            '& .next': {
                borderRadius: '4px',
                /* textTransform: 'uppercase', */
            },
        },
        headerLeft: {
            display: 'flex',
            width: 'fit-content',
            alignItems: 'center',
            '& .MuiIconButton-root': {
                color: color.color4,
                fontWeight: '600',
                marginLeft: '-10px',
            },
            '& .MuiTypography-root': {
                fontSize: '17px',
                fontWeight: '400',
                color: color.color4,
            }
        },
        containerCircle: {
            minWidth: '15px',
            paddingTop: 1.2
        },
        circle: {
            width: '5px',
            height: '5px',
            backgroundColor: color.color13,
            borderRadius: '50%',
        },
        textList: {
            //display: 'flex',
            // alignItems: 'start',
            // gap: 1,
            //mt: 0.5,
            textAlign: 'start !important',
            //width: '100%',
            color:color.color13
        },
        containerChild: {
            /* display: 'flex',
            flexDirection: 'column',
            gap: 1 */
            '& .title_text':{
                width:'100%',
                marginBottom:1,
                //textAlign:'start !important',
                color:color.color13
                //display:'box'
            }

        },
    }
}

export { useStyles }